import React from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { useSelector } from 'react-redux';
import { RootState } from 'src/shared/state/store';
import AccountNameViewer from 'src/pages/accountSettings/components/AccountDetails/AccountNameViewer';
import AccountNameForm from 'src/pages/accountSettings/components/AccountDetails/AccountNameForm';

interface AccountNameProps {
  displayName?: string;
}

const AccountName = ({ displayName = '' }: AccountNameProps) => {
  const methods = useForm({
    mode: 'onBlur',
    defaultValues: {
      displayName,
    },
  });

  const isEditMode = useSelector(
    (state: RootState) => state.accountSettings.accountNameEditMode,
  );

  return (
    <FormProvider {...methods}>
      {isEditMode ? <AccountNameForm /> : <AccountNameViewer />}
    </FormProvider>
  );
};

export default AccountName;
